import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex, Text, Image, VStack, HStack, Badge, Divider, Button, Icon, ChakraProvider } from '@chakra-ui/react';
import { FaUser, FaCalendarDay, FaMapMarkerAlt, FaPhone, FaEnvelope, FaBriefcase, FaTint, FaIdBadge, FaClipboardList, FaStethoscope, FaClock, FaCheckCircle } from 'react-icons/fa';
import { extendTheme } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { userBarcode } from '../../redux/actions/Admin.action';

const theme = extendTheme({
  colors: {
    'theme-color': '#F5EAD5',
    'green-color': '#042B10',
    'theme-dark': '#B78234',
  },
  boxShadow: {
    'shadows': '0 0 10px rgba(0,0,0,0.3)',
  },
});

const staticUserData = {
  firstName: 'ASDD',
  middleName: 'GH',
  lastName: 'GH',
  gender: 'Male',
  dateOfBirth: '2024-08-28',
  nationality: 'asd',
  country: 'ads',
  state: 'asd',
  city: 'aasd',
  area: 'asd',
  address: 'asd',
  pincode: '784578',
  phoneNumber: '7245784578',
  email: 'asd@gmail.com',
  occupation: 'asd',
  bloodGroup: 'asd',
  photo: 'https://via.placeholder.com/200',
  branch: 'hrththerhre',
  leadReceived: 'justdialApp',
  problem: ['Overweight and Obesity'],
  leadStatus: 'inProcess',
  campaign: [
    {
      cname: 'Walk-in',
      description: 'asd',
    },
  ],
  reference: [
    {
      personDetail: 'john',
      doctorDetail: '',
    },
  ],
  remark: 'asd',
  nextFollowUpDate: '2024-09-14',
  from: '2024-09-11T11:16:00.000Z',
  to: '2024-09-11T14:14:00.000Z',
  doctorName: 'krishna',
  counselorAssign: 'Jane Doe',
  leadFollowUpRemark: 'asdasd',
  createdBy: 'Master',
  patientcode: '8106',
};

const staticAppointmentsData = [
  {
    _id: { time: '01:40' },
    appointments: [
      {
        _id: '66dfd72133cc7e0c878181ba',
        patientId: '66dea091aef36f3a7cfa7a3b',
        firstName: 'john',
        middleName: 'eth',
        phoneNumber: '1478523690',
        lastName: 'shah',
        dateOfAppointment: '2024-09-09T20:10:00.000Z',
        issue: ['Overweight and Obesity'],
        bookingType: 'Pre-Booked',
        branch: 'Central Branch',
        doctor: 'Dr. John Does',
        reference: [{ personDetail: 'naresh', doctorDetail: '', _id: '66dea0bdaef36f3a7cfa7a62' }],
        subReference: 'test',
        remark: 'fewef',
        notification: ['email'],
        status: 'confirm',
        time: '01:40',
        createdAt: '2024-09-10T05:20:33.784Z',
        updatedAt: '2024-09-10T10:52:59.155Z',
        patientType: 'new',
      },
    ],
    count: 1,
  },
  {
    _id: { time: '01:40' },
    appointments: [
      {
        _id: '66dfd72133cc7e0c878181ba',
        patientId: '66dea091aef36f3a7cfa7a3b',
        firstName: 'john',
        middleName: 'eth',
        phoneNumber: '1478523690',
        lastName: 'shah',
        dateOfAppointment: '2024-09-09T20:10:00.000Z',
        issue: ['Overweight and Obesity'],
        bookingType: 'Pre-Booked',
        branch: 'Central Branch',
        doctor: 'Dr. John Does',
        reference: [{ personDetail: 'naresh', doctorDetail: '', _id: '66dea0bdaef36f3a7cfa7a62' }],
        subReference: 'test',
        remark: 'fewef',
        notification: ['email'],
        status: 'confirm',
        time: '01:40',
        createdAt: '2024-09-10T05:20:33.784Z',
        updatedAt: '2024-09-10T10:52:59.155Z',
        patientType: 'new',
      },
    ],
    count: 1,
  },
];


const BarCode = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const barcodeData = useSelector((state) => state.admin)

  useEffect(() => {
    const payload = {
      barcode: slug
    }
    dispatch(userBarcode(payload))
  }, [])

  const userData = barcodeData?.userBarcode?.data?.PatientData;

  return (
    <ChakraProvider theme={theme}>
      <Flex direction="column" minHeight="100vh" bg="white" p={4}>
        <Flex maxW="1200px" mx="auto" flexDir="column" w="full">
          <VStack spacing={8} align="stretch">
            {
              userData && (
                <>
                  {/* User Info Section */}
                  <Flex direction="column" align="center" mb={8}>
                    <Image
                      src={staticUserData.photo}
                      alt="User Photo"
                      borderRadius="full"
                      boxSize="150px"
                      mb={4}
                      borderWidth="4px"
                      borderColor="green-color"
                      boxShadow="shadows"
                    />
                    <Text fontSize="4xl" fontWeight="bold" color="green-color" textAlign="center">
                      {userData.firstName} {userData.lastName}
                    </Text>
                    <Text fontSize="xl" color="theme-dark">{userData.phoneNumber}</Text>
                  </Flex>

                  {/* User Details Section */}
                  <Box p={6} borderRadius="md" boxShadow="shadows" borderWidth="1px" borderColor="green-color" bg="white">
                    <Text fontSize="2xl" fontWeight="bold" mb={4} color="green-color">
                      User Details
                    </Text>
                    <Divider borderColor="green-color" mb={4} />
                    <VStack spacing={4} align="start">
                      <HStack spacing={4}>
                        <Icon as={FaUser} color="green-color" boxSize={6} />
                        <Text><strong>Name:</strong> {userData.firstName} {userData.lastName}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaCalendarDay} color="green-color" boxSize={6} />
                        <Text>  <strong>Date of Birth:</strong> {new Date(userData.dateOfBirth).toLocaleDateString('en-GB')}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaMapMarkerAlt} color="green-color" boxSize={6} />
                        <Text><strong>Address:</strong> {userData.address}, {userData.city}, {userData.state}, {userData.country}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaPhone} color="green-color" boxSize={6} />
                        <Text><strong>Phone:</strong> {userData.phoneNumber}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaEnvelope} color="green-color" boxSize={6} />
                        <Text><strong>Email:</strong> {userData.email}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaBriefcase} color="green-color" boxSize={6} />
                        <Text><strong>Occupation:</strong> {userData.occupation}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaTint} color="green-color" boxSize={6} />
                        <Text><strong>Blood Group:</strong> {userData.bloodGroup}</Text>
                      </HStack>
                      <HStack spacing={4}>
                        <Icon as={FaIdBadge} color="green-color" boxSize={6} />
                        <Text><strong>Patient Code:</strong> {userData.patientcode}</Text>
                      </HStack>
                    </VStack>
                  </Box>
                </>
              )
            }


            {/* Appointments Section */}
            <Box bg="theme-color" p={6} borderRadius="md" boxShadow="shadows" w="full">
              <Text fontSize="2xl" fontWeight="bold" mb={4} color="green-color">
                Appointments
              </Text>
              <Divider borderColor="green-color" mb={4} />

              {barcodeData?.userBarcode?.data?.appointmentData?.map((appointment, index) => (
                <Box
                  key={index}
                  mb={6}
                  p={6}
                  borderRadius="md"
                  borderWidth="1px"
                  borderColor="green-color"
                  bg="white"
                  boxShadow="shadows"
                  position="relative"
                  _notLast={{ mb: 10 }}
                >
                  <HStack justifyContent="space-between" mb={4}>
                    <Text fontSize="lg" fontWeight="bold" color="green-color">
                      Time: {appointment.time}
                    </Text>
                    <Badge colorScheme={appointment.status === 'confirm' ? 'green' : 'red'}>
                      {appointment.status}
                    </Badge>
                  </HStack>
                  <VStack align="start" spacing={3}>
                    {/* {appointment.appointments.map((appt, apptIndex) => ( */}
                      <Box key={index} w="full">
                        <HStack spacing={3}>
                          {/* <Icon as={FaUser} color="green-color" boxSize={5} /> */}
                          <Text className='py-1'><strong className='me-2'>Patient:</strong> {appointment.firstName} {appointment.lastName}</Text>
                        </HStack>
                        <HStack spacing={3}>
                          {/* <Icon as={FaClipboardList} color="green-color" boxSize={5} /> */}
                          <Text className='py-1'><strong className='me-2'>Issue:</strong> {appointment.issue.join(', ')}</Text>
                        </HStack>
                        <HStack spacing={3}>
                          {/* <Icon as={FaBriefcase} color="green-color" boxSize={5} /> */}
                          <Text className='py-1'><strong className='me-2'>Booking Type:</strong> {appointment.bookingType}</Text>
                        </HStack>
                        <HStack spacing={3}>
                          {/* <Icon as={FaBuilding} color="green-color" boxSize={5} /> */}
                          <Text className='py-1'><strong className='me-2'>Branch:</strong> {appointment.branch}</Text>
                        </HStack>
                        <HStack spacing={3}>
                          {/* <Icon as={FaStethoscope} color="green-color" boxSize={5} /> */}
                          <Text className='py-1'><strong className='me-2'>Doctor:</strong> {appointment.doctor}</Text>
                        </HStack>
                        <HStack spacing={3}>
                          {/* <Icon as={FaClock} color="green-color" boxSize={5} /> */}
                          <Text><strong className='me-2'>Time:</strong> {appointment.time}</Text>
                        </HStack>
                      </Box>
                    {/* ))} */}
                  </VStack>
                </Box>
              ))}
            </Box>
          </VStack>
        </Flex>
      </Flex>
    </ChakraProvider>
  );
};

export default BarCode;
